module.exports = __webpack_public_path__ + "assets/img/tabs4.c975cbb2.png";